import { KeyValueTranslated } from '../models/translation';

export enum AustraliaTaxValidator {
  TfnValidator = 'TfnValidator',
  AusTaxExemptionReasonValidator = 'AusTaxExemptionReasonValidator'
}

export enum OverseasTaxValidator {
  CountryValidator = 'CountryValidator',
  TinValidator = 'TinValidator',
  OverseasTaxExemptionReasonValidator = 'OverseasTaxExemptionReasonValidator',
  OverseasTaxExemptionExplanationValidator = 'OverseasTaxExemptionExplanationValidator',
  TaxTypeUsValidator = 'TaxTypeUsValidator'
}

export const US_TAX_MAX_LENGTH = 9;

export enum UsTinType {
  SSN = 'SSN',
  ITIN = 'ITIN'
}

export const US_TAX_TYPE: KeyValueTranslated = {
  [UsTinType.SSN]: (t) => t('Social Security Number (SSN)'),
  [UsTinType.ITIN]: (t) => t('Individual Taxpayer Identification Number (ITIN)')
};
